<template>
  <tr
    :class="[
      'ms-tr ms-tr-grid-viewer',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
      dataRow.isDisabledCheckBox ? 'ms-format-noedit' : '',
      {'action-hover': showRowAction && actionInline},
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
    v-if="!dataRow.isHide || !groupField"
  >
    <td v-if="multiple" :class="['ms-td multiple-cell sticky ms-col-td-multiple', dbOptionHeight]">
      <ms-checkbox
        :checked="isChecked"
        :dataRow="dataRow"
        @input="checkMultiple"
        class="justify-center"
        ref="multiple"
        checkOnly
        :disabled="disabledCheckedMultipleTbody || disabled || dataRow.isDisabledCheckBox"
        :key="0"
      />
    </td>
    <td :key="0" v-if="serial" class="ms-td serial text-center" :class="{sticky: hasLockColumn}">
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columns"
      :key="col.dataField"
      class="ms-td ms-col-td"
      :class="[
        col.cssCellClass,
        {sticky: col.lock},
        index === columns?.length - 1 ? 'ms-col-td-last' : '',
        dbOptionHeight,
      ]"
      :style="styleWidth(col, false)"
      :ref="`td-${col.dataField}`"
    >
      <component
        v-if="col.template"
        :is="col.template"
        :data="dataRow"
        :column="col"
        :dataRow="dataRow"
        :col="col"
        :rowSelected="rowSelected"
        :isSelected="isSelected"
        :lineBreak="lineBreak"
      ></component>
      <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
        <span>{{ index + 1 }}</span>
      </div>

      <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
      <div
        v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
        :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'icon24', 'more-rows']"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        @click="viewMoreDetails(col, dataRow)"
      >
        <span></span>
      </div>
      <div
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
          getErrorMsg(col, dataRow) ? 'ms-tr-text-validate' : '',
          col.showAiIcon && showAiRender ? 'flex-left' : '',
          col.showAiIcon && dataRow.is_ai_render ? 'row-ai-render' : ''
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        v-else
      > 
        <div v-if="col.showAiIcon && showAiRender" class = 'cls-ic-ai-render'>
          <div
            :class="['icon24 left-icon ic-ava']" 
            v-if="dataRow.is_ai_render"
            v-tooltip="'Chứng từ thêm nhanh bởi AVA'"
          ></div>
        </div>

        <div
          :class="['icon24 left-icon error icon-validate']"
          v-if="getErrorMsg(col, dataRow)"
          v-tooltip="getErrorMsg(col, dataRow)"
        ></div>
        <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
        <!-- kiểu checkbox -->
        <span
          v-if="col.formatType === $ms.constant.FormatType.Checkbox"
          class="cell-checkbox"
          :ref="`text-${col.dataField}`"
        >
          <div class="icon" :class="{checked: dataRow[col.dataField]}"></div>
        </span>
        <!-- kiểu html -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.HtmlQlts"
          class="customStyleHtml"
          v-html="
            $ms.format.formatData($ms.commonFn.processXssValue(dataRow[col.dataField]), {
              formatType: col.formatType,
            })
          "
          :title="dataRow[`${col.dataField}Raw`] || $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              formatString: col.formatString,
            })"
        ></div>
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.Html"
          class="customStyleHtml"
          v-html="$ms.commonFn.processXssValue(dataRow[col.dataField])"
          :title="dataRow[`${col.dataField}Raw`] || $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              formatString: col.formatString,
            })"
        ></div>
   
        <!--  Sửa bởi ldduy 15.1.2024 - thêm tham số isTooltip = true cho hàm formatData để phân biệt đang format cho tooltip -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.HtmlAccess"
          class="customStyleHtml"
          v-html="
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
            })
          "
          :title="dataRow[`${col.dataField}Raw`] || $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              formatString: col.formatString,
            }, true)" 
        ></div>
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.HtmlNormal"
          class="customStyleHtml"
          v-html="
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
            })
          "
          :title="dataRow[`${col.dataField}Raw`] || $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              formatString: col.formatString,
            })"
        ></div>
        <span
          v-else
          :class="[
            `text-${col.align || 'left'} ${col.linkedForm ? 'text-link' : ''}`,
            `${lineBreak == 1 ? 'ms-td-normal-span' : lineBreak == 2 ? 'ms-td-normal-span-two-line' : ''}`,
          ]"
          :ref="`text-${col.dataField}`"
          :title="dataRow[`${col.dataField}Raw`] || 
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              formatString: col.formatString,
            })
          "
          @click="viewLinkedForm(col, dataRow)"
        >
          {{
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              isShowZero: isShowZero,
              formatString: col.formatString,
            })
          }}
        </span>

        <!-- <div
          :class="['mi', 'mi-24', col.icon.type]"
          v-if="col.icon && col.icon.show(dataRow, col)"
          v-tooltip="{ ...col.icon.tooltip }"
        ></div> -->
      </div>
    </td>
    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky" :class="[dbOptionHeight]">
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
import i18nValidate from '@/i18ns/vi/i18nValidate';
import MsTdIcon from '@/components/gridViewer/MsTdIcon.vue';
import {defineComponent, computed, getCurrentInstance} from 'vue';
export default {
  name: 'msTr',
  components: {MsTdIcon},
  props: {
    isShowZero: {
      default: true,
      type: Boolean,
    },
    //Lưu thông tin của các cột
    columns: {},
    //Lưu dữ liệu của dòng
    dataRow: {},
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    groupField: {
      default: [],
      type: Array,
    },
    // Hiện thị số dòng cho phép.
    lineBreak: {
      default: 1,
      type: Number,
    },
    // Có ít 
    showAiRender: {
      default: false,
      type: Boolean,
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.command.more');
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      let result = [],
        actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      let result = [],
        actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     * Modified by nbtin 14.03.2023: thêm biến để case trường hợp vừa check vừa disable
     */
    isChecked() {
      const {disabledCheckedMultipleTbody, isCheckedAll, isSelected, dataRow} = this;
      return disabledCheckedMultipleTbody || dataRow.isDisabledCheckBox
        ? dataRow.checkedAndDisabled || false
        : isCheckedAll || isSelected;
    },
  },
  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
    };
  },
  setup() {
    const {proxy} = getCurrentInstance();
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    return {dbOptionHeight};
  },
  methods: {
    //Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    //Created by LTDAT
    styleWidth(col, widget) {
      let rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    //(Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    //Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * dtnga3 (14.07.2022)
     */
    viewLinkedForm(col, dataRow, e) {
      if (col && col.linkedForm && col.linkedForm != '') {
        this.$emit('viewLinkedForm', col, dataRow, e);
      }
    },

    //Emit sự kiện ấn phím ra ngoài grid
    //Created by LTDAT(13/06/2020)
    row_keydown(e) {
      const me = this;
      me.$emit(me.$ms.constant.CustomEvent.MsKeydown, me.dataRow, e);
    },

    //Sự kiện click vào nút chọn ở cột multiple
    //Created by LTDAT (28.05.2020)
    //NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
    return '';
      let me = this;
      if (col.formatType == me.$ms.constant.FormatType.Html) {
        if (dataRow[col.dataField]) {
          return me.stripHtml(dataRow[col.dataField]);
        } else {
          return null;
        }
      } else {
        //Format dạng MOREDETAILS
        if (dataRow[col.dataField] === 'MORE_DETAILS') {
          return me.$t('i18nCommon.command.ViewMoreDetails');
        }

        //pvduy 24/04/2021: xử lý riêng toolip giá trị khác trong báo cáo thống kê số lượng theo tình trạng.
        if (col.dataField === 'AssetStatusName' && dataRow[col.dataField] === 'Khác') {
          return 'Báo mất, báo hỏng, đề nghị thanh lý, đang điều chuyển';
        } else {
          return this.$ms.format.formatData(dataRow[col.dataField], {
            formatType: col.formatType,
            enumName: col.enum,
            dataRow: dataRow,
            optionFormat: col.optionFormat,
          });
        }
      }
    },
    /**
     * convert html code to text
     */
    stripHtml(source) {
      let output;
      source = source.toString();
      //get rid of HTML tags
      output = source.replace(/<[^>]*>/g, '');
      output = output.replace(/&nbsp;/g, ' ');
      output = output.replace(/\n/g, '; ');
      return output;
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          let liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          let [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          let elSub = menuSub.$el; // element sub
          let elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
    /**
     * Lấy error conent show tooltip
     * TVDAT 20/03/2022
     */
    getErrorMsg(col, dataRow) {
      let rules = col.rules;
      let titleErr = col.caption;
      let message = '';
      //Validate luôn theo rule được xử lý bên ngoài
      if (col.customValidate && typeof col.customValidate === 'function') {
        message = col.customValidate(col, dataRow);
        if (message) {
          return message;
        }
      }
      if (rules && Array.isArray(rules) && rules.length > 0) {
        for (let index = 0; index < rules.length; index++) {
          const rule = rules[index];
          if (rule) {
            const {name, compareValue, customValidate} = rule;
            const controlValue = dataRow[col.dataField];
            //Nếu có custom validate sẽ lấy theo customvalidate
            if (customValidate && typeof customValidate === 'function') {
              message = customValidate(controlValue, compareValue, titleErr, dataRow);
              if (message) {
                return message;
              }
            } else {
              message = this.handlerRule(name, titleErr, controlValue, compareValue);
              if (message) {
                return message;
              }
            }
          }
        }
      }
    },
    /**
     * Xử lý các rule validate
     * TVDAT 20/03/2022
     */
    handlerRule(rule, titleCol, controlValue, compareValue) {
      let message = '';
      switch (rule) {
        case 'required':
          if (
            controlValue === undefined ||
            controlValue === null ||
            controlValue === NaN ||
            controlValue === '' ||
            controlValue == 0
          ) {
            message = i18nValidate.messages[rule](titleCol, true);
          }
          break;
        // case 'moreThan':
        //   break;
        // case 'lessThan':
        //   break;
        // case 'lessThanAmount':
        //   if (
        //     controlValue !== undefined &&
        //     controlValue !== null &&
        //     !isNaN(controlValue) &&
        //     compareValue !== undefined &&
        //     compareValue !== null &&
        //     !isNaN(compareValue)
        //   ) {
        //     if (parseInt(controlValue) > 0) {
        //       if (parseInt(controlValue) >= parseInt(compareValue)) {
        //         message = i18nValidate.messages[rule](titleError);
        //       }
        //     } else {
        //       if (parseInt(controlValue) <= parseInt(compareValue) * -1) {
        //         message = i18nValidate.messages[rule](titleError);
        //       }
        //     }
        //   }
        //   break;
        // case 'equals':
        //   break;
        // case 'pattern':
        //   if (!validateText.validateRule(compareValue, controlValue)) {
        //     message = i18nValidate.messages['email'](titleError);
        //   }
        //   break;
        // case 'diffierentZero':
        //   if (!validateNumber.validatediffierentZero(controlValue)) {
        //     message = i18nValidate.messages['diffierentZero'](titleError);
        //   }
        //   break;
        default:
          break;
      }
      return message;
    },

    /**
     * Kiểm tra có ít nhất 1 dòng do AI render
     * dtnga3 (03.10.2024)
     */
    checkHasAIRenderAtLeast(col, dataRow) {
      
    },
  },
};
</script>
<style lang="scss">
.ms-grid-viewer {
  .ms-content--table {
    @import '@/assets/scss/components/MsTrViewer.scss';
  }
}
</style>
